export default "__VITE_ASSET__8c681b91__"